import { useContext } from "react"
import { Card, Tab, Tabs } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { authContext } from "../../context/AuthContext"
import { checkSpeciality } from "../../utils/checkSpeciality"
import AtencionesPrevias from "../doctor/AtencionesPrevias"
import FichaEpidemiologicaColombia from "../doctor/FichaEpidemiologicaColombia"
import ProvArchivos from "../proveedor/ProvArchivos"
import ProvHistoriaClinica from "../proveedor/ProvHistoriaClinica"
import ProvHistorialCitas from "../proveedor/ProvHistorialCitas"

function CardActionMedicalColombia({t, cita, setShowModalServer, setErrorServer, validDiagnostico, scrollRef, setCita, reload, setReload}){
    const {scheduleDTO, patientDTO} = cita
    const {auth} = useContext(authContext)


    return (
        <Card className="shadow-1 mb-3">
            <Card.Body>
                <Tabs defaultActiveKey="historial_citas" className="tabs-conference" transition={false}>
                    <Tab eventKey="historial_citas" title={t('historial_citas')}>
                        {
                            (scheduleDTO.doctor?.id && patientDTO.id) && 
                                <ProvHistorialCitas
                                    cita={cita} 
                                    paciente={patientDTO} 
                                    idDoctor={scheduleDTO.doctor.id} 
                                    idPaciente={patientDTO.id} 
                                    showAddCita={ patientDTO?.account?.id != null }
                                /> 
                        }
                    </Tab>
                    <Tab 
                        eventKey="historia_clinica" 
                        title={
                            checkSpeciality(Number(cita.speciality.id)) ?
                            "Resumen de consulta" :
                            t('historia_clinica')
                        }>
                            <ProvHistoriaClinica 
                                appointmentId={cita.id} 
                                idHM={cita.medicalHistoryDTO.id} 
                                auth={auth}
                                idSpeciality={Number(cita.speciality.id)}
                                setShowModalServer={setShowModalServer}
                                setErrorServer={setErrorServer}
                                validDiagnostico={validDiagnostico}
                                scrollRef={scrollRef}
                                setCita={setCita}
                                age={cita.ageDTO}
                                reload={reload}
                                setReload={setReload}
                                cita={cita}
                            />
                    </Tab>
                    <Tab eventKey="archivos" title="Archivos">
                        <ProvArchivos 
                            appointmentId={cita.id} 
                            auth={auth} 
                        />
                    </Tab>
                    <Tab eventKey="fichaepidemiologica" title="Ficha epidemiológica">
                        <FichaEpidemiologicaColombia
                            appointmentId={cita.id} 
                            idHM={cita.epidemiologicalFileDTO?.id} 
                            auth={auth}
                            idSpeciality={Number(cita.speciality.id)}
                            setShowModalServer={setShowModalServer}
                            setErrorServer={setErrorServer}
                            scrollRef={scrollRef}
                            cita={cita}
                        />
                    </Tab>
                    <Tab eventKey="atencionprevia" title="Atenciones previas">
                        <AtencionesPrevias
                            cita={cita} 
                            auth={auth}
                            setShowModalServer={setShowModalServer}
                            setErrorServer={setErrorServer}
                        />
                    </Tab>
                </Tabs>
            </Card.Body>
        </Card>
    )

}
export default withTranslation()(CardActionMedicalColombia)